// extracted by mini-css-extract-plugin
export default {"protocols":"ProtocolList_protocols__ls-4y"};